import {
  addDoc,
  collection,
  DocumentReference,
  DocumentSnapshot,
  getDocs,
  onSnapshot,
  query,
  QueryConstraint,
  Unsubscribe,
} from 'firebase/firestore'

import { Message } from 'Types'
import { filterMap } from 'Utils'

import { authState } from '../auth'

import { chatsCollection } from './chats'

const buildMessages = (docs: DocumentSnapshot[]) => docs.map((doc) => ({ ...doc.data(), id: doc.id }) as Message)

const messagesCollection = (chatId: string) => collection(chatsCollection(), chatId, 'messages')

export const getMessages = async (
  chatId: string,
  ...queryConstraints: QueryConstraint[]
): Promise<[messages: Message[], cursors: { endCursor?: DocumentSnapshot; startCursor?: DocumentSnapshot }]> => {
  const messagesQuery = query(messagesCollection(chatId), ...queryConstraints)
  const snapshot = await getDocs(messagesQuery)
  const startCursor = snapshot.docs[0]
  const endCursor = snapshot.docs[snapshot.docs.length - 1]
  const messages = buildMessages(snapshot.docs)
  return [messages, { endCursor, startCursor }]
}

type OnMessages = (messages: Message[]) => void
export const subscribeOnMessages = (chatId: string, ...options: [...QueryConstraint[], OnMessages]): Unsubscribe => {
  const onMessages = options.pop() as OnMessages
  const queryConstraints = options as QueryConstraint[]

  const messagesQuery = query(messagesCollection(chatId), ...queryConstraints)

  return onSnapshot(messagesQuery, (snapshot) => {
    const docs = filterMap(snapshot.docChanges(), (change) => (change.type === 'added' ? change.doc : undefined))
    onMessages(buildMessages(docs))
  })
}

export const createMessage = async (chatId: string, body: string): Promise<DocumentReference> => {
  const message = {
    action: 'message',
    body,
    authorId: authState.uid,
    timestamp: new Date(),
  }

  return addDoc(messagesCollection(chatId), message)
}
